// api接口
const apiUrl = {
  index: {
    getList: '/trs/order/new-order',
    receiving: '/trs/order/receiving-order',
    auth: '/trs/user/get-permissions'
  },
  saveSearchHistory: '/trs/vehicle-maintain/save-search-list',
  getSearchHistory: '/trs/vehicle-maintain/get-search-history',
  clearSearchHistory: '/trs/vehicle-maintain/del-search-history',
  modifyInfo: '/trs/order/modify-info',
  getFaultType: '/trs/order/get-fault-type',
  logDetails: '/trs/job-log/details',
  orderModify: '/trs/order/modify',
  modifyJobLog: 'trs/job-log/modify-job-log',
  jobLogDelete: '/trs/job-log/delete',
  getRecords: '/trs/job-log/get-records',
  buttonJudge: '/trs/job-log/button-judge',
  healcarItem: '/trs/job-log/healcar-item',
  saveJobLog: '/trs/job-log/save-job-log',
  jobLog: '/trs/job-log/get-job-log',
  getAllPlateNum: '/trs/order/get-plate-numbers',
  getCarInfo: '/trs/order/get-car-info',
  getUserCoupon: '/trs/order/get-user-coupon', // 获取车辆用户的优惠券
  getCouponDetail: '/trs/coupon/get-coupon-detail', // 获取车辆用户的优惠券详情
  getSendUserTodayOrderNum: '/trs/order/get-send-user-today-order-num', // 获取售后人员今日接单数量
  getCarInfoByPn: '/trs/gps-binding/get-car-info',
  deleteOrder: '/trs/order/delete',
  maintainItem: '/trs/outside/get-order-maintain-item',
  createOrder: '/trs/order/create',
  sendUser: '/trs/user/send-user',
  searchPlatenumber: '/trs/order/search',
  allOrderSearch: '/trs/order/all-order-search',
  allOrderFilter: '/trs/order/all-order-filter',
  setHistory: '/trs/order/search-history',
  sendTime: '/trs/outside/save-time',
  saveProcess: '/trs/maintain-process/add-maintain-process',
  backPhone: '/trs/outside/back-phone',
  getProcess: '/trs/maintain-process/list',
  backOutside: '/trs/maintain/back-outside',
  sendUserOrder: '/trs/order/send',
  clearSendUser: '/trs/user/clear-send-user',
  phoneHandle: '/trs/order/phone-handle',
  addOutsideInfo: '/trs/outside/add-outside-info',
  getOutsideInfo: '/trs/outside/get-outside-info',
  saveOutsideInfo: '/trs/outside/save-outside-info',
  repairItemOpts: '/trs/outside/get-maintain-item',
  saveRepairItem: '/trs/outside/maintain-item',
  detail: '/trs/order/order-detail', // 工单详情
  reminderOverReply: '/trs/order/reminder-over-reply',
  getSpvByCity: '/api-maintain-platform/assistant/reservation/get-spv-by-city', // 根据城市获取spv
  sites: '/trs/maintain/get-site', // 获取维修站信息
  saveMaintain: '/trs/maintain/add-maintain-info', // 维修厂登录保存
  workingInfo: '/trs/maintain/working-info', // 保存工时
  installationKit: '/trs/maintain/parts-info', // 保存零配件
  extraCharge: '/trs/maintain/additional-cost', // 保存附加费
  upDatePhoto: '/trs/upload/image', // 上传图片
  getMaintain: '/trs/maintain/get-maintain-info', // 获取维修登记信息
  changePassWord: '/trs/user/modify-password', // 修改密码
  gerVisit: '/apis/trs/uservisit/get-visit', // 获取回访记录
  saveVisit: '/apis/trs/uservisit/add-visit', // 添加回访记录
  siteInfo: '/trs/maintain/site-info', // 获取每个维修站的附加信息

  getEvaluateRef: '/apis/trs/uservisit/get-evaluate-ref', // 获取调查问卷配置
  getEvaluate: '/apis/trs/uservisit/get-evaluate', // 获取调查问卷
  submitEvaluate: '/apis/trs/uservisit/submit-evaluate', // 提交调查问卷

  clearCid: '/trs/user/clear-cid',
  sendOrder: '/trs/order/send-order',
  saveUser: '/trs/user/save-send-user',
  getChart: '/trs/order/statistic',
  checkCarList: '/trs/purchasing-car/list',
  checkCarInfo: '/trs/purchasing-car/info',
  saveVinNum: '/trs/purchasing-car/save-frame-number',
  vinNumberSearch: '/trs/purchasing-car/frame-number',
  saveCheckInfo: '/trs/purchasing-car/save-info',
  checkDetail: '/trs/purchasing-car/details',
  getCarBrand: '/trs/purchasing-car/get-car-brand',
  errorReson: '/trs/purchasing-car/abnormal-reason',
  getStation: '/trs/purchasing-car/get-station',
  createAbnormalCard: '/trs/purchasing-car/create-abnormal-card',
  searchIndexNumber: '/trs/car/plate-number',
  searchIndexSaveNumber: '/trs/car/save-plate-number',
  searchIndexClearNumber: '/trs/car/clear-plate-number',
  replaceCarNo: '/trs/replace-car/car-no',
  saveReplaceCarNo: '/trs/replace-car/save-car-no',
  searchIndexCarInfo: '/trs/car/car-info',
  searchIndexCarRent: '/trs/car/car-rent',
  handoverCar: '/trs/handover-car/list',
  handoverNum: '/trs/handover-car/plate-number',
  saveHandoverNum: '/trs/handover-car/save-plate-number',
  getDeliveryList: '/trs/handover-car/get-delivery',
  getCarDelivery: '/trs/handover-car/get-send-car-delivery',
  saveDelivery: '/trs/handover-car/save-delivery',
  createCarDelivery: '/trs/handover-car/create-car-delivery',
  carDeliveryDetail: '/trs/handover-car/get-car-delivery-detail',
  saveDeliveryCode: '/trs/handover-car/save-delivery-code',
  deliveryCode: '/trs/handover-car/delivery-code',
  dstImage: '/trs/upload/dst-image',
  backCarList: '/trs/back-car/list',
  backCarNumber: '/trs/back-car/plate-number',
  backCarSaveNumber: '/trs/back-car/save-plate-number',
  backCarDetail: '/trs/back-car/get-details',
  getLossDeterStatus: '/trs/smart-fee-quotation/check-smart-fee',
  backCarCreate: '/trs/back-car/create-fixed-loss',
  replaceCarList: '/trs/replacement-car/list',
  replaceCarCode: '/trs/replace-car/order-code',
  saveReplaceCarCode: '/trs/replace-car/save-order-code',
  verificationCode: '/trs/handover-car/verification-code',
  saveVerificationCode: '/trs/handover-car/save-verification-code',
  replaceCarNum: '/trs/replace-car/plate-number',
  saveReplaceCarNum: '/trs/replace-car/save-plate-number',
  createReplaceCarDelivery: '/trs/replacement-car/create-replace-car-delivery-order',
  createReplaceCarReturn: '/trs/replace-car/create-replace-car-fixed-loss',
  uploadSignature: '/trs/user/signature',
  getSignature: '/trs/user/get-signature',
  appdelivreryImage: '/trs/handover-car/appdelivrery-image',
  deliveryCache: '/trs/handover-car/create-car-delivery-cache',
  getDeliveryCache: '/trs/handover-car/get-create-car-delivery-cache',
  createReplaceDeliveryCache: '/trs/replace-car/create-car-delivery-cache',
  getReplaceDeliveryCache: '/trs/replace-car/get-create-car-delivery-cache',
  getReplaceReturnCache: '/trs/replace-car/get-create-replace-car-fixed-loss-cache',
  createReplaceReturnCache: '/trs/replace-car/create-replace-car-fixed-loss-cache',
  createReturnCarCache: '/trs/back-car/create-fixed-loss-cache',
  getReturnCarCache: '/trs/back-car/get-create-fixed-loss-cache',
  getTboxInfo: '/vehicleOperate/trs/openapi/backcar/getCarTboxStatus',
  delivreryList: '/trs/handover-car/get-appdelivrery-components',
  tboxList: '/trs/device-binding/list',
  brandList: '/trs/device-binding/get-device-brands',
  vincodeList: '/trs/car/get-vin-codes',
  brandTypeList: '/trs/device-binding/get-brand-types',
  searchItem: '/trs/device-binding/search-items',
  searchItemSave: '/trs/device-binding/search-items-save',
  createVinSave: '/trs/car/set-vin-codes',
  deviceBrand: '/trs/device-binding/save',
  tboxDetail: '/trs/device-binding/detail',
  getInfoByCarVin: '/trs/car/get-car-info',
  editTbox: '/trs/device-binding/edit',
  tboxWatch: '/trs/device-binding/watch',
  getReason: '/trs/replacement-car/get-rep-reason',
  getDeliveryTypeOpts: '/trs/replacement-car/get-delivery-way',
  replacementDetail: '/trs/replacement-car/detail',
  replacementCreate: '/trs/replacement-car/create',
  replacementEdit: '/trs/replacement-car/edit',
  replacementInvalid: '/trs/replacement-car/invalid-order',
  orgTree: '/trs/u/get-server-org-tree',
  orgList: '/trs/u/get-server-org-list',
  searchClienName: '/trs/handover-car/client-name',
  saveClienName: '/trs/handover-car/save-client-name',
  backClienName: '/trs/back-car/client-name',
  saveBackClienName: '/trs/back-car/save-client-name',
  searchServiceCode: '/trs/handover-car/service-order-code',
  saveServiceCode: '/trs/handover-car/save-service-order-code',
  replaceClienName: '/trs/replace-car/client-name',
  saveReplaceClienName: '/trs/replace-car/save-client-name',
  insuranceList: '/trs/car/insurance-list',
  insuranceDetail1: '/trs/car/insurance-compulsory',
  insuranceDetail2: '/trs/car/insurance-commercial',
  dangerList: '/trs/car/bein-danger-list',
  dangerDetail: '/trs/car/bein-danger-list',
  reminderSave: '/trs/order/order-reminder-save',
  replacementDemand: '/trs/order/send-replace-car-demand',
  saveCheckItem: '/trs/purchasing-car/save-item',
  dingdingUsers: '/trs/user/dingding-user-list',
  getCompanyList: '/trs/purchasing-car/get-company-station-list',
  purStationList: '/trs/purchasing-car/station-list',
  savePlateNumbers: '/trs/order/save-plate-numbers-search',
  skuGoods: '/trs/car/sku-goods',
  getRetro: 'trs/handover-car/get-retrofitting',
  getDeliveryRetro: 'trs/handover-car/get-delivery-retrofitting',
  getRetroList: 'trs/handover-car/get-retrofitting-components',
  saveRetro: 'trs/handover-car/save-retrofitting',
  getSmartDevicesByCarNo: 'trs/back-car/exist-smart-devices-by-car-no',
  sceneRepair: {
    addKit: '/trs/outside/add-maintain-item',
    delKit: '/trs/outside/del-maintain-item'
  },
  carBaseInfo: {
    operatingCertificate: '/trs/car/operating-certificate-list',
    carCertificate: '/trs/car/car-certificate-list',
    travelCertificate: '/trs/car/travel-certificate-list',
    ticketList: '/trs/car/ticket-list',
    repairList: '/trs/car/repair-list',
    recordList: '/app/maintain/recordList'
  },
  recordCar: {
    taskSave: '/trs/vehicle-inventory/task-save',
    accountTaskSave: '/trs/vehicle-account-inventory/task-save',
    taskList: '/trs/vehicle-inventory/task-list',
    accountTaskList: '/trs/vehicle-account-inventory/task-list',
    taskCodeList: '/trs/vehicle-inventory/task-code-list',
    saveTaskCode: '/trs/vehicle-inventory/save-task-code-list',
    taskInfo: '/trs/vehicle-inventory/task-info',
    accountTaskInfo: '/trs/vehicle-account-inventory/task-info',
    taskDelete: '/trs/vehicle-inventory/task-delete',
    accountTaskDelete: '/trs/vehicle-account-inventory/task-delete',
    carInfo: '/trs/vehicle-inventory/car-info',
    carIdentify: '/trs/vehicle-inventory/car-identify',
    saveIdentify: '/trs/vehicle-inventory/car-save',
    carCheck: '/trs/vehicle-inventory/car-plate-number',
    taskSearchName: '/trs/vehicle-inventory/task-name-list',
    taskSearchNameSave: '/trs/vehicle-inventory/save-task-name-list',
    taskNumSave: '/trs/vehicle-inventory/car-add',
    exceptionAdd: '/trs/vehicle-account-inventory/exception-car-add',
    carEdit: '/trs/vehicle-account-inventory/car-edit',
    getTags: '/trs/vehicle-account-inventory/get-car-inventory-tag',
    getReason: '/trs/vehicle-account-inventory/get-exception-reason',
    carVerify: '/trs/vehicle-account-inventory/car-verify',
    accountCarInfo: '/trs/vehicle-account-inventory/car-info',
    carDelete: '/trs/vehicle-inventory/car-delete',
    accountTaskCodeList: '/trs/vehicle-account-inventory/task-code-list',
    accountSaveTaskCode: '/trs/vehicle-account-inventory/save-task-code-list',
    accountTaskSearchName: '/trs/vehicle-account-inventory/task-name-list',
    statusList: '/trs/vehicle-status-inventory/task-list',
    taskStatusList: '/trs/vehicle-status-inventory/task-car-list',
    taskCarDetail: '/trs/vehicle-status-inventory/car-info',
    taskCarCreateDetail: '/trs/vehicle-status-inventory/car-info-by-plate-number',
    statusCarAdd: '/trs/vehicle-status-inventory/car-add',
    optsConfig: '/trs/vehicle-status-inventory/inventory-config-list',
    statusCarEdit: '/trs/vehicle-status-inventory/car-edit',
    accountTaskSearchNameSave: '/trs/vehicle-account-inventory/save-task-name-list',
    statusInventorySwitch: '/trs/vehicle-account-inventory/change-status-inventory-switch'
  },
  safetyPage: {
    list: '/trs/safety-check/list',
    listTotal: '/trs/safety-check/list-total',
    info: '/trs/safety-check/info',
    detail: '/trs/safety-check/detail',
    confirm: '/trs/safety-check/confirm',
    save: '/trs/safety-check/save',
    feedback: '/trs/safety-check/feedback',
    taskNoList: '/trs/safety-check/task-no-list',
    taskNoSave: '/trs/safety-check/task-no-save',
    taskTitleList: '/trs/safety-check/task-title-list',
    taskTitleSave: '/trs/safety-check/task-title-save'
  },
  bindGps: {
    list: '/trs/gps-binding/list',
    searchItems: '/trs/gps-binding/search-items',
    searchItemsSave: '/trs/gps-binding/search-items-save',
    watch: '/trs/gps-binding/watch',
    gpsSave: '/trs/gps-binding/save',
    gpsEdit: '/trs/gps-binding/edit', // gps绑定修改
    gpsInfo: '/trs/gps-binding/gps-info',
    searchGps: '/trs/gps-binding/search-gps',
    searchGpsSave: '/trs/gps-binding/search-gps-save',
    unbind: '/trs/gps-binding/un-bind', // gps解绑
    searchKey: '/trs/gps-binding/search-key-word' // 根据关键字搜索车架号或设备出厂编码
  },
  thirdRepair: {
    indexList: '/trs/repair-stock-car/list',
    plateNumberList: '/trs/repair-stock-car/plate-number-list',
    savePlateNumberList: '/trs/repair-stock-car/save-plate-number-list',
    vincodeList: '/trs/repair-stock-car/vin-code-list',
    saveVincodeList: '/trs/repair-stock-car/save-vin-code-list',
    registrCatch: '/trs/repair-stock-car/get-fault-registr-catch',
    detailListInfo: '/trs/repair-stock-car/detailed-list-info',
    saveRegistr: '/trs/repair-stock-car/fault-registr',
    listCount: '/trs/repair-stock-car/list-count',
    create: '/trs/repair-stock-car/create',
    carInfo: '/trs/repair-stock-car/car-info',
    stationTree: '/trs/repair-stock-car/station-tree',
    confirm: '/trs/repair-stock-car/confirm',
    faultRegistr: '/trs/repair-stock-car/fault-registr',
    siteTreeList: '/trs/repair-stock-car/site-tree-list',
    selfBuildList: '/trs/repair-stock-car/self-build-list',
    detailedListRegistr: '/trs/repair-stock-car/detailed-list-registr',
    addTime: '/trs/repair-stock-car/add-task-time',
    delTime: '/trs/repair-stock-car/del-task-time',
    addMaterial: '/trs/repair-stock-car/add-material',
    delMaterial: '/trs/repair-stock-car/del-material',
    taskTimeCache: '/trs/repair-stock-car/task-time-info',
    info: '/trs/repair-stock-car/info',
    nullifyOrder: '/trs/repair-stock-car/nullify-repair-order',
    itemList: '/trs/repair-stock-car/repair-item-list',
    couponList: '/trs/coupon/order-list',
    getStationAndUserInfo: 'trs/vehicle-status-inventory/get-station-and-user-info', // 盘车转维修获取详情
    carSaveReservation: '/trs/repair-stock-car/stock-car-save-reservation', // 库存车工单转小超
    pullInRepairInfo: '/trs/repair-stock-car/pull-in-repair-info', // 进站维修
    maintainRepairInfo: '/trs/repair-stock-car/maintain-repair-info', // 进站维修（小超）
    getWaitRepairPlans: '/trs/repair-stock-car/get-wait-repair-plans'// 需维修定损项
  },
  thirdaNew: {
    auditList: '/trs/maintain-audit/audit-list',
    auditInfo: '/trs/maintain-audit/audit-info',
    orderInfo: '/trs/maintain-audit/order-info',
    couponInfo: '/trs/maintain-audit/coupon-info',
    auditGoods: '/trs/maintain-audit/audit-goods',
    auditLog: '/trs/maintain-audit/audit-log',
    audit: '/trs/maintain-audit/audit',
    claimAuditLog: '/trs/maintain-audit/claim-audit-log',
    auditGoodsLog: '/trs/maintain-audit/audit-goods-log'
  },
  thirdRepairAudit: {
    limitMoney: '/trs/order/limit-money',
    auditOrderList: '/trs/order/audit-order-list',
    auditFittingsList: '/trs/order/audit-fittings-list',
    auditCheck: '/trs/order/audit-check',
    auditOrderCount: '/trs/order/audit-order-count',
    accidentdetail: '/trs/accident-car/order-detail',
    renovationdetail: '/trs/renovation-car/order-detail',
    rectificationdetail: '/trs/rectification-car/order-detail',
    halfYearLog: '/trs/order-audit/get-maintain-time-log',
    halfYearLaoTieLog: '/trs/order-audit/get-repair-time-log',
    getLaoTieDetail: '/trs/order-audit/get-repair-log-detail',
    getMaintainDetail: '/trs/order-audit/get-maintain-log-detail',
    getMixTimeLog: '/trs/order-audit/get-mix-time-log'
  },
  thirdRepairClose: {
    auditFeeList: '/trs/order-audit/audit-fee-list',
    auditFeeCount: '/trs/order-audit/audit-fee-count',
    costCenter: '/trs/order-audit/card-payment-order-cost-center',
    auditFeeCommit: '/trs/order-audit/audit-fee-commit',
    auditpushNc: '/trs/order-audit/push-nc'
  },
  maintainOrder: {
    indexList: '/trs/vehicle-maintain/order-list',
    plateNumberList: '/trs/repair-stock-car/plate-number-list',
    savePlateNumberList: '/trs/repair-stock-car/save-plate-number-list',
    vincodeList: '/trs/repair-stock-car/vin-code-list',
    saveVincodeList: '/trs/repair-stock-car/save-vin-code-list',
    registrCatch: '/trs/repair-stock-car/get-fault-registr-catch',
    detailListInfo: '/trs/repair-stock-car/detailed-list-info',
    saveRegistr: '/trs/repair-stock-car/fault-registr',
    listCount: '/trs/repair-stock-car/list-count',
    create: '/trs/repair-stock-car/create',
    carInfo: '/trs/repair-stock-car/car-info',
    stationTree: '/trs/repair-stock-car/station-tree',
    confirm: '/trs/repair-stock-car/confirm',
    faultRegistr: '/trs/repair-stock-car/fault-registr',
    siteTreeList: '/trs/repair-stock-car/site-tree-list',
    selfBuildList: '/trs/repair-stock-car/self-build-list',
    detailedListRegistr: '/trs/repair-stock-car/detailed-list-registr',
    addTime: '/trs/repair-stock-car/add-task-time',
    delTime: '/trs/repair-stock-car/del-task-time',
    addMaterial: '/trs/repair-stock-car/add-material',
    delMaterial: '/trs/repair-stock-car/del-material',
    taskTimeCache: '/trs/repair-stock-car/task-time-info-catch',
    info: '/trs/repair-stock-car/info',
    nullifyOrder: '/trs/repair-stock-car/nullify-repair-order',
    itemList: '/trs/repair-stock-car/repair-item-list'
  },
  dangerHandle: {
    list: '/trs/safety-danger/list',
    initInfo: '/trs/safety-danger/doing-info-init',
    detail: '/trs/safety-danger/info',
    catch: '/trs/safety-danger/doing-info-catch',
    submit: '/trs/safety-danger/doing-info-reply',
    dangerCode: '/trs/safety-danger/safety-danger-code',
    listCount: '/trs/safety-danger/list-count',
    saveDangerCode: '/trs/safety-danger/save-danger-code'
  },
  checkDanger: {
    list: '/trs/safety-danger/check-list',
    listCount: '/trs/safety-danger/check-list-count',
    initInfo: '/trs/safety-danger/check-info-init',
    catch: '/trs/safety-danger/check-info-catch',
    submit: '/trs/safety-danger/check-info-reply'
  },
  clientInfomation: {
    list: '/trs/customer/list',
    dict: '/trs/customer/simple-dict',
    record: '/trs/car/get-history-repair-record',
    saveClient: '/trs/customer/save-client',
    catch: '/trs/customer/catch-client',
    submit: '/trs/customer/edit-client',
    saveClientB: '/trs/customer/save-business',
    getCacheC: '/trs/customer/catch-client-get',
    getCacheB: '/trs/customer/catch-business-get',
    catchB: '/trs/customer/catch-business',
    submitB: '/trs/customer/edit-business',
    categoryList: '/trs/customer/category-list',
    customList: '/trs/customer/customer-list',
    detail: '/trs/customer/info',
    childDict: '/trs/customer/child-dict',
    qcc: '/trs/customer/qcc-details',
    classB: '/trs/customer/customer-class-b',
    category: '/trs/customer/category-list',
    areaTree: '/trs/customer/area-tree-list',
    searchCustomer: '/trs/customer/search-customer',
    saveSearchCustomer: '/trs/customer/save-customer',
    searchPhone: '/trs/customer/search-phone',
    saveSearchPhone: '/trs/customer/save-phone',
    listCount: '/trs/customer/list-count',
    verify: '/trs/customer/verify'
  },
  insurance: {
    searchCarNo: '/trs/insurance-claim/search-carno',
    saveCarNo: '/trs/insurance-claim/save-carno',
    searchCustomername: '/trs/insurance-claim/search-customername',
    searchCaseNo: '/trs/insurance-claim/search-casenumber',
    saveCaseNo: '/trs/insurance-claim/save-casenumber',
    saveCustomername: '/trs/insurance-claim/save-customername',
    list: '/trs/insurance-claim/lists',
    listCount: '/trs/insurance-claim/lists-count',
    editOverview: '/trs/insurance-claim/edit-overview',
    upload: '/trs/insurance-claim/batchupload-enclosure',
    deleteFile: '/trs/insurance-claim/delete-enclosure',
    editTargetCar: '/trs/insurance-claim/edit-target-car',
    getMaints: '/trs/insurance-claim/get-maints',
    editThreeParty: '/trs/insurance-claim/edit-three-party',
    delThreeParty: '/trs/insurance-claim/del-three-party',
    editInjury: '/trs/insurance-claim/edit-human-injury',
    delInjury: '/trs/insurance-claim/del-human-injury',
    editDamage: '/trs/insurance-claim/edit-material-damage',
    delDamage: '/trs/insurance-claim/del-material-damage',
    saveAccount: '/trs/insurance-claim/save-budget-account',
    delAccount: '/trs/insurance-claim/unset-budget-account',
    saveSettlement: '/trs/insurance-claim/save-settlement',
    delSettlement: '/trs/insurance-claim/del-settlement',
    approval: '/trs/insurance-claim/start-a2-approval',
    endCase: '/trs/insurance-claim/end-claim-case',
    endBill: '/trs/insurance-claim/complete-claim-bill',
    cancelCase: '/trs/insurance-claim/cancel-claim-case',
    detail: '/trs/insurance-claim/detail'
  },
  goTelephone: {
    cooperationSave: '/trs/order/transfer-cooperation-save',
    selfSave: '/trs/order/self-employment-save',
    // 工时配件增删改查
    addTime: '/trs/outside/save-task-time',
    delTime: '/trs/outside/del-task-time',
    addMaterial: '/trs/outside/save-material',
    delMaterial: '/trs/outside/del-material',
    taskTimeCache: '/trs/outside/task-time-info'
  },
  chargeOrder: {
    orderList: '/trs/charge-pile/order-list',
    orderListCount: 'trs/charge-pile/order-list-count',
    stationList: '/trs/charge-pile/charge-station-list',
    create: '/trs/charge-pile/create',
    orderConfirm: '/trs/charge-pile/order-confirm',
    faultRegist: '/trs/charge-pile/fault-regist',
    addMaterial: '/trs/charge-pile/add-repair-material',
    areaList: '/trs/charge-pile/area-list',
    addRepair: '/trs/charge-pile/add-repair-material',
    delRepair: '/trs/charge-pile/del-repair-material',
    customList: '/trs/customer/simple-customer-list',
    searchCreater: '/trs/charge-pile/search-creater',
    saveCreater: '/trs/charge-pile/save-creater',
    searchCustomer: '/trs/charge-pile/search-customer',
    saveCustomer: '/trs/charge-pile/save-customer',
    searchSend: '/trs/charge-pile/search-send-user',
    saveSend: '/trs/charge-pile/save-send-user',
    searchOrderId: '/trs/charge-pile/search-order-id',
    customListSave: '/trs/customer/save-simple-customer-list',
    orderDetail: '/trs/charge-pile/order-info',
    factoryRegList: '/trs/charge-pile/factory-reg-list',
    outsideRegList: '/trs/charge-pile/outside-reg-list',
    factoryList: '/trs/charge-pile/factory-list',
    belongAreaList: '/trs/charge-pile/belong-area-list',
    belongProvinceList: '/trs/charge-pile/belong-province-list',
    belongCityList: '/trs/charge-pile/belong-city-list',
    factorySave: '/trs/charge-pile/factory-reg-save',
    outsideSave: '/trs/charge-pile/outside-reg-save',
    outsideDel: '/trs/charge-pile/outside-reg-del',
    factoryDel: '/trs/charge-pile/factory-reg-del',
    phoneSave: '/trs/charge-pile/phone-reg-pile-save',
    phoneDel: '/trs/charge-pile/phone-reg-pile-del',
    phoneList: '/trs/charge-pile/phone-reg-pile-list',
    changeuser: '/trs/charge-pile/send',
    reminderOrder: '/trs/charge-pile/order-reminder-save'
  },
  smartDamage: {
    partList: '/trs/smart-loss/appearance-parts-ref',
    mechanicsList: '/trs/smart-loss/mechanics-parts-ref',
    damageDegree: '/trs/smart-loss/check-damage-degree',
    planInfo: '/trs/smart-loss/plan-info',
    mechanicsDamageDegree: '/trs/smart-loss/mechanics-damage-degree',
    planCity: '/trs/smart-loss/plans-city',
    planCityClass: '/trs/smart-loss/plans-city-car-class',
    savePlan: '/trs/smart-loss/save-compare-plans',
    regionList: '/trs/smart-fee-record-damage/get-car-region-list',
    regionCount: '/trs/smart-fee-record-damage/get-car-region-count',
    getRepairParts: '/trs/smart-fee-record-damage/get-repair-parts-list',
    carCheckPlan: '/trs/smart-loss/car-check-plan',
    damageDraftSave: '/trs/smart-fee-record-damage/damage-draft-save', // 定损草稿保存
    getDamageDraft: '/trs/smart-fee-record-damage/get-damage-draft' // 获取定损草稿
  },
  collectMoney: {
    orderList: '/trs/collect-money/order-list',
    orderInfo: '/trs/collect-money/order-info',
    orderCreate: '/trs/collect-money/create-order',
    orderStatus: '/trs/collect-money/order-status',
    mobileExist: '/trs/collect-money/mobile-exist',
    memberRegister: '/trs/collect-money/member-register',
    smsCode: '/trs/collect-money/sms-code',
    projectList: '/trs/collect-money/project-list',
    mobileList: '/trs/collect-money/mobile-list',
    orderDel: '/trs/collect-money/order-del',
    customList: '/trs/collect-money/customer-list'

  },
  fileLend: {
    list: '/borrow/borrow/list',
    selectItems: '/borrow/borrow/select-items',
    orgTree: '/basic-data/server-org-tree',
    updateCache: '/borrow/borrow/create-cache',
    dingTop: '/borrow/borrow/ding-top',
    del: '/borrow/borrow/del',
    edit: '/borrow/borrow/edit',
    create: '/borrow/borrow/create',
    editDetail: '/borrow/borrow/edit-detail',
    detail: '/borrow/borrow/detail',
    getPlate: '/car/get-plate-numbers',
    getVin: '/trs/car/get-vin-codes',
    getCarInfo: '/car/get-car-info',
    listSearcher: '/borrow/borrow/list-searcher',
    getCache: '/borrow/borrow/get-create-cache'
  },
  carBreakRule: {
    list: '/mtc/ticket/operation-list',
    listCount: '/mtc/ticket/operation-list-total',
    detail: '/mtc/ticket/operation-list-detail',
    remarkDetail: '/mtc/ticket/remark-detail',
    selectItems: '/mtc/ticket/select-items'
  },
  carYearCheck: { // 车辆年审
    getDict: '/basic-data/get-dict',
    list: '/mtc/driver-license/remind-list',
    detail: '/mtc/driver-license/remind-detail',
    typeSelect: '/mtc/driver-license/break-audit-type', // 脱审类型列表
    selectItems: '/mtc/driver-license/select-items',
    breakAudit: '/mtc/driver-license/break-audit', // 脱审登记
    annualAudit: '/mtc/driver-license/create-annual-audit-rec', // 年审登记
    breakAuditList: '/mtc/driver-license/break-audit-list', // 脱审记录列表
    annualAuditList: '/mtc/driver-license/annual-audit-list', // 年审记录列表
    updataImg: '/trs/upload/image', // 上传
    getExceptionData: '/mtc/driver-license/get-exception-data', // 获取异常数据
    submitAssign: '/mtc/driver-license/assign', // 指派
    handleException: '/mtc/driver-license/dispose-exception', // 异常处理
    supplierList: '/basic-data/get-supplier-list', // 供应商
    getEnableTree: '/basic-data/get-enable-tree', // 费用类型列表
    getConstList: '/basic-data/get-const-list', // 税率列表
    getBasicUsers: '/basic-data/get-users', // 员工列表
    commitSupplier: '/mtc/driver-license/get-fee-by-supplier'
  },
  cardYearCheck: { // 营运证年审
    list: '/mtc/ope-lic/remind-lists',
    detail: '/mtc/ope-lic/get-car-info-by-vincode',
    selectItems: '/mtc/ope-lic/select-items',
    wzNum: '/mtc/ope-lic/car-wz-count', // 违章数
    annualAudit: '/mtc/ope-lic/record-add', // 年审登记
    annualAuditList: '/mtc/ope-lic/record-lists', // 年审记录列表
    updataImg: '/trs/upload/image', // 上传
    suppList: '/mtc/ope-lic/supplier-list' // 供应商列表
  },
  carPassCard: { // 车辆通行证
    list: '/aftersales-vehicle/auth/permit/task/page',
    remindList: '/aftersales-vehicle/auth/permit/record/page',
    taskNumber: '/aftersales-vehicle/auth/permit/task/taskNumber',
    detail: '/aftersales-vehicle/auth/permit/task/findById',
    annualAudit: '/aftersales-vehicle/auth/permit/task/register', // 登记
    taskAdd: '/aftersales-vehicle/auth/permit/task/create', // 续办
    cancelData: '/aftersales-vehicle/auth/permit/task/cancel', // 作废
    annualAuditDetail: '/aftersales-vehicle/auth/permit/record/findById', // 记录详情
    recordList: '/aftersales-vehicle/auth/permit/record/findRecordByCarId'
  },
  driveCardHandle: { // 行驶证新办
    // list: '/mtc/dri-lic-task/get-task-list', // 自持/新车销售
    list: '/renewal/dri-lic-task/get-task-list', // 自持/新车销售
    recordFinish: '/mtc/dri-lic-task/get-finish-record-list', // 办理记录/完成上牌
    recordBreak: '/mtc/dri-lic-task/get-stop-record-list', // 办理记录/终止上牌
    moreAdd: '/mtc/dri-lic-task/deal-tax', // 批量办税
    moreCheck: '/mtc/dri-lic-task/deal-test', // 批量检测
    detail: '/mtc/dri-lic-task/get-task-detail',
    breakTask: '/mtc/dri-lic-task/break-up-task', // 终止上牌
    getRecordDetail: '/mtc/dri-lic-task/get-record-detail', // 完成上牌详情
    getStopDetail: '/mtc/dri-lic-task/get-stop-task-detail', // 终止上牌详情
    certificateData: '/mtc/dri-lic-task/certificate-import', // 通过ocr登记信息
    editInfoData: '/mtc/dri-lic-task/update-certificate-info', // OCR识别登记-编辑
    oneRegister: '/mtc/dri-lic-task/register', // 单条登记
    register: '/mtc/dri-lic-task/batch-register' // OCR识别登记
    // taskAdd: '/mtc/permit/task-add', // 续办
    // cancelData: '/mtc/permit/task-cancel', // 作废
    // annualAuditDetail: '/mtc/permit/record-detail', // 记录详情
    // updataImg: 'trs/upload/dst-image', // 上传
    // recordList: '/mtc/permit/record-list'
  },
  fixedLoss: {
    accessoryList: '/trs/smart-fee-record-accessory/get-java-data', // 随车信息
    modifiedList: '/trs/smart-fee-quotation/get-java-data', // 加装信息
    batteryList: '/trs/smart-fee-record-battery/get-java-data', // 电池定损
    damageList: '/trs/smart-fee-record-damage/get-java-data' // 损伤定损
  },
  operationHome: {
    queryDemandBillPage: '/dst-apis/1/vehicleOperate/openapi/demandBill/queryDemandBillPage', // 获取车辆需求单分页数据
    getDemandBillStatistics: '/dst-apis/1/vehicleOperate/openapi/demandBill/getDemandBillStatistics', // 车辆需求单统计
    getStationList: '/dst-apis/1/vehicleOperate/openapi/workorder/getStationList', // 获取场站列表
    setDefauleStation: '/dst-apis/1/vehicleOperate/openapi/workorder/setDefaultStation' // 设置默认场站
  }
}
export default apiUrl



// WEBPACK FOOTER //
// ./src/api/api.js